import TypeCancellationSelect from './type-cancellation-select';

export default {
  name: 'investment-proposal-type-cancellation-select',

  block: 'type-cancellation-select',

  extends: TypeCancellationSelect,
};
